import React, { Fragment } from 'react';

/**
 * Formats bio text by converting line breaks into proper paragraphs and preserving formatting
 * @param text - The raw bio text to format
 * @returns JSX elements with proper paragraph formatting
 */
export function formatBioText(text: string): React.ReactElement[] | null {
  if (!text || !text.trim()) {
    return null;
  }

  // Split by double line breaks to identify paragraphs
  const paragraphs = text.split(/\n\s*\n/).filter(p => p.trim());
  
  return paragraphs.map((paragraph, index) => {
    // Convert single line breaks within paragraphs to <br> elements
    const lines = paragraph.trim().split('\n');
    
    return (
      <p key={index} className="text-gray-600 mb-4 last:mb-0">
        {lines.map((line, lineIndex) => (
          <Fragment key={lineIndex}>
            {line}
            {lineIndex < lines.length - 1 && <br />}
          </Fragment>
        ))}
      </p>
    );
  });
}